<template>      
  <div class="d1">
    <div class="d2" v-if="post.fields">
      <div class="d2a">
        <img class="logo" v-if="!isMobile" style="opacity: 0;" :src="`https:${post.fields.logo.fields.file.url}`" :alt="post.fields.logo.fields.title">
        <h1 class="title">{{`${post.fields.partnerName}`}}</h1>        
        <img :class="['logo', 'd2a2' ]" @click="openUrl" :src="`https:${post.fields.logo.fields.file.url}`" :alt="post.fields.logo.fields.title">
        
        
      </div>
      <div class="d2b">
        <h2 class="d2b1">{{ `${post.fields.title}` }}</h2>
        <div class="d2b2" v-html="description"></div>
        <h2 class="d2b3">{{ `${post.fields.couponTitle}` }}</h2>
        <gallery v-if="coupons && coupons.length > 0" :images="coupons"></gallery>  
        <gallery2 v-if="images && images.length > 0" :images="images"></gallery2>  
      </div>
    </div>
  </div>
</template>

<script>
import {client} from '../contentful';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import Gallery from './Gallery.vue';
import Gallery2 from './Gallery2.vue';
import { INLINES } from '@contentful/rich-text-types';

export default {
  components: { Gallery, Gallery2  },
  data() {
    return {
      post: {},
      isMobile: false,
      minw: 0,  
    }
  },
  computed: {
    description() {
      const options = {
        renderNode: {
          'embedded-asset-block': (node) => {
            if( node.data.target && node.data.target.fields.file){
              return `<img
                src="https://${node.data.target.fields.file.url}" 
                width=70%
                alt="${node.data.target.fields.title}"
              >`  
            } else {
              return '<div>Embedded asset not found: ' + node.data.target.fields.file.url + '</div>';
            }
          },
          [INLINES.HYPERLINK]: (node) => {
            // if(node.data.uri.includes('target=blank')){                            
            //   return (`<a href="${node.data.uri}" target="_blank">${node.content[0].value}</a>`)              
            // } else if(node.data.uri.includes('youtube')){    
            if(node.data.uri.includes('youtube')){    
              return (`<iframe title="YouTube video for blog post" style="aspect-ratio: 1/1; max-height: 80vh;" width="100%" src="${node.data.uri}?rel=0&amp;controls=0&amp;mute=1&amp;autoplay=1&amp;loop=1&amp;playlist=Ip7gjI2LGZM" frameborder="0" allow="autoplay; accelerometer; modestbranding; encrypted-media; web-share; gyroscope; picture-in-picture" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`)             
            } else {
              return (`<a href="${node.data.uri}" target="_blank">${node.content[0].value}</a>`)              
            }
          },
        }
      };      
      if(this.post && this.post.fields){        
        console.log("DTHS: " +documentToHtmlString(this.post.fields.description, options));
        return documentToHtmlString(this.post.fields.description, options);
      } else {
        return '<div>No Description</div>';
      }
    },
    imageSource() {
      if(this.post && this.post.fields){
        return documentToHtmlString(this.post.fields.imageSource);
      }
      else {
        return '<div></div>';
      }
    },
    coupons() {
      const imgs = [];
      if(this.post && this.post.fields && this.post.fields.coupons){ 
        this.post.fields.coupons.forEach((img) => {
          imgs.push({
            src: `https:${img.fields.file.url}`,
            width: img.fields.file.details.image.width,
            height: img.fields.file.details.image.height,
            title: img.fields.title
          })
        })        
      }
      return imgs;
    },
    images() {
      const imgs = [];
      if(this.post && this.post.fields && this.post.fields.images){              
        this.post.fields.images.forEach((img) => {
          imgs.push({
            src: `https:${img.fields.file.url}`,
            width: img.fields.file.details.image.width,
            height: img.fields.file.details.image.height,
            title: img.fields.title
          })
        })        
      }
      return imgs;
    },    
  },
  methods: {
    windowSize () {
      if (window.innerWidth <= 900) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    updateScroll () {
      const curPos = window.scrollY
      if (curPos < this.scrollPosition) {
        this.showHeader = true
      } else if (curPos > this.scrollPosition) {
        this.showHeader = false
      }
      this.scrollPosition = window.scrollY
    },    
    updateViewport() {      
      this.minw = window.screen.width*.75 + 'px';
    },
    openUrl() {
      window.open(this.post.fields.partnerWebsite, '_blank');
    }
  },
  created() {
    // const isPreview = this.$route.query.preview==='true';
    const slug = this.$route.params.slug;
    const contentfulCient = client;
    contentfulCient
      .getEntries({ content_type: 'partner', 'fields.slug': slug })
      .then((response) => {
        this.post = response.items[0];     
      })
      .catch(console.error);    

    // this.categories.push('All');
    // contentfulCient.getEntries( {content_type: 'Partner'});    
    // .then((response) => {
    //   response.items.forEach((post) => {
    //     if(post.fields.category && !this.categories.includes(post.fields.category)){
    //       this.categories.push(post.fields.category);
    //     }        
    //   });      
    // });
  },
  mounted() {
    this.windowSize();
    window.addEventListener('resize', this.windowSize);   
    window.addEventListener('scroll', this.updateScroll)   
    window.scrollTo({
      top:0,
      left:0,
      behavior: 'smooth'
    });
    window.addEventListener('resize', this.updateViewport)    
    this.updateViewport();
    
  },
  
};
</script>

<style scoped>
* { 
    -moz-box-sizing: border-box; 
    -webkit-box-sizing: border-box; 
     box-sizing: border-box; 
}

.title {
  margin:0;  
  padding: 0 !important;
  font-family: 'Anonymous Pro';
  font-size: 60px;
  color: v-bind(colorRed);
  /* font-weight: 700 !important; */
  text-align: left !important;
  text-shadow:0 4px 4px rgba(0, 0, 0, 0.35);
}
h2 {
  font-family: 'Anaheim';
  /* font-style: bold !important; */
  font-size: 36px !important;
  margin: 0;
  padding: 0;
  margin-top: 60px;
  font-weight: 700 !important;
}

.d1 {
  width: 100%;
  color: v-bind(colorRed);
  min-width: v-bind(minw);
}

.d2 {
  width: 100%;
}
.d2a {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  position: absolute;
  top: 120px;
  left: 0;
  width: 100%;
  min-width: v-bind(minw);
  padding: 0 !important;
}
.d2a2:hover {
  cursor: pointer;

}

.d2b {
  margin-left: 12%;
  margin-right: 12%;
  /* display: flex;
  flex-direction: column; */
}
.d2b1 {
  margin-bottom: 20px;
}
.d2b2 {
  font-family: 'Akatab';
  font-size: 28px;
}
.d2b3 {
  color: v-bind(colorPurple);   
  margin-bottom: 20px;
}


.logo {
  max-width: 15%;
  max-height:220px;
  object-fit: contain;
  /* margin-left: 40px; */
}



@media only screen and (max-width: 900px) {
  .d2 {
    width: 90%;
    margin-left: 5%;
  }
  .d2a {
    position: relative;
    top: 0;    
    margin-top: -50px;
    justify-content: space-between;    
  }
  .d2b {
    width: 100%;
    margin: 0;
  }
  .d2b1 {
    font-size: 30px !important;
  }
  .d2b2 {
    font-size: 22px !important;
  }
  .d2b3 {
    font-size: 30px !important;
  }
  .logo {
    max-width: 22%;
  }
  .title {
    font-size: 40px;
  }
}
</style>